import { Route, Routes } from "react-router-dom";
import ManageToDoItemsRouter from "./ManageToDoItems";
import MockACTEventsRouter from "./MockACTEvents";

export default function SchedulingRouter() {
  return (
    <Routes>
      <Route path="/to-do-items/*" element={<ManageToDoItemsRouter />} />
      <Route path="/mock-acts/*" element={<MockACTEventsRouter />} />
    </Routes>
  );
}
